import React, { ReactNode, FC, useMemo } from 'react';

import { StyledBar } from './ActionBar.styles';

export interface ActionBarProps {
  /** The bar content. Usually PrimaryButton and SecondaryButton. */
  children?: ReactNode;
  /** Removes the padding. */
  nopadding?: boolean;
  /** The minimum button width before they wrap. */
  minButtonWidth?: number;
  /** Stretches the buttons to the size of the bar. Overrides the default of the theme. */
  flexButtons?: boolean;
  /** Stretches the buttons to the size of the bar on XS breakpoint. */
  flexButtonsXs?: boolean;
}

const StyledBarDefaultProps = {
  nopadding: false,
};

const ActionBar: FC<ActionBarProps> = ({ nopadding, minButtonWidth, flexButtons, ...props }) => {
  const buttonFlexGrow = useMemo(() => {
    if (flexButtons === true) return 1;
    if (flexButtons === false) return 0;
    return undefined;
  }, [flexButtons]);

  return (
    <StyledBar
      nopadding={nopadding}
      minButtonWidth={minButtonWidth}
      {...props}
      buttonFlexGrow={buttonFlexGrow}
    />
  );
};

ActionBar.defaultProps = StyledBarDefaultProps;

export default ActionBar;
